import { render, staticRenderFns } from "./ShopTour.vue?vue&type=template&id=076f318c&scoped=true&"
import script from "./ShopTour.vue?vue&type=script&lang=js&"
export * from "./ShopTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f318c",
  null
  
)

export default component.exports